import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { getApiBaseUrl, GET_LOCATIONS } from "../../../Config/Config";
import { Spin } from "antd";
import FilterTreeAddAreaModel from "./FilterTreeAddAreaModel";
import FilterTreeAddBlockModels from "./FilterTreeAddBlockModels";
import FilterTreeAddAhuModel from "./FilterTreeAddAhuModel";
import FilterTreeAddFilterModel from "./FilterTreeAddFilterModel";
import FilterTreeEditAhuModel from "./FilterTreeEditAhuModel";
import FilterTreeEditFilterModel from "./FilterTreeEditFilterModel";
import FilterTreeEditBlock from "./FilterTreeEditBlock";
import FilterTreeEditArea from "./FilterTreeEditArea";
// import { useNavigate } from "react-router-dom";
// import { all_routes } from "../../../../../Router/all_routes";

const FiltersTree = () => {
  // const navigate = useNavigate();

  const [blocks, setBlocks] = useState([]);
  const [areas, setAreas] = useState([]);
  const [AHU, setAHU] = useState([]);
  const [filters, setFilters] = useState([]);

  const [treeSelectedBlock, setTreeSelectedBlock] = useState(null);
  console.log(
    treeSelectedBlock,
    "treeSelectedBlocktreeSelectedBlocktreeSelectedBlock",
  );
  const [treeSelectedArea, setTreeSelectedArea] = useState(null);
  const [treeSelectedAHU, setTreeSelectedAHU] = useState(null);

  const [loadingTreeBlocks, setLoadingTreeBlocks] = useState(false);
  const [loadingTreeAreas, setLoadingTreeAreas] = useState(false);
  const [loadingTreeAHU, setLoadingTreeAHU] = useState(false);
  const [loadingTreeFilters, setLoadingTreeFilters] = useState(false);

  const [treeBlockModal, setTreeBlockModal] = useState({
    open: false,
  });
  const [treeAreaModal, setTreeAreaModal] = useState({
    open: false,
  });
  const [AhuModal, setAhuModal] = useState({
    open: false,
  });
  const [AddFilterModal, setAddFilterModal] = useState({
    open: false,
  });

  const [editBlockModal, setEditBlockModal] = useState({ open: false });
  const [editTreeSelectedBlock, setEditTreeSelectedBlock] = useState(null);

  const [editAreaModal, setEditAreaModal] = useState({ open: false });
  const [editTreeSelectedArea, setEditTreeSelectedArea] = useState(null);

  console.log(editAreaModal, "editAreaModal");
  console.log(editTreeSelectedArea, "editTreeSelectedArea");

  console.log(editBlockModal);
  console.log(editTreeSelectedBlock);

  const [editAhuModal, setEditAhuModal] = useState({ open: false });
  const [editTreeSelectedAhu, setEditTreeSelectedAhu] = useState(null);
  const [Fitermodel, setFitermodel] = useState(null);

  // const [editBlockModel, setEditBlockModel] = useState({ open: false });
  // const [editTreeSelectedBlock, setEditTreeSelectedBlock] = useState(null);

  const [editFilterModel, setEditFilterModel] = useState({ open: false });
  const [editTreeSelectedFilter, setEditTreeSelectedFilter] = useState(null);

  const [clickedBlock, setClickedBlock] = useState(null);
  const [clickedArea, setClickedArea] = useState(null);

  const user = JSON.parse(sessionStorage.getItem("UserType") || "{}");

  const fetchBlocks = async () => {
    setLoadingTreeBlocks(true);
    try {
      const response = await fetch(`${getApiBaseUrl()}${GET_LOCATIONS}`);
      const result = await response.json();
      setBlocks(result?.ResultData || []);
    } catch (error) {
      console.error("Error fetching blocks:", error);
    } finally {
      setLoadingTreeBlocks(false);
    }
  };

  const fetchAreas = async () => {
    if (!treeSelectedBlock?.id == null) {
      return;
    }
    setLoadingTreeAreas(true);
    try {
      const response = await fetch(
        `${getApiBaseUrl()}/Areas/getblockareas?BlockId=${treeSelectedBlock.id}`,
      );
      const result = await response.json();
      setAreas(result?.ResultData || []);
    } catch (error) {
      console.error("Error fetching blocks:", error);
    } finally {
      setLoadingTreeAreas(false);
    }
  };

  const fetchAHU = async () => {
    if (!treeSelectedBlock?.id || !treeSelectedArea?.id) return;

    setLoadingTreeAHU(true);
    try {
      const response = await fetch(
        `${getApiBaseUrl()}/ahuph2/getahu?BlockId=${
          treeSelectedBlock.id
        }&AreaId=${treeSelectedArea.id}`,
      );
      const result = await response.json();
      setAHU(result?.ResultData || []);
    } catch (error) {
      console.error("Error fetching blocks:", error);
    } finally {
      setLoadingTreeAHU(false);
    }
  };

  const fetchFilters = async () => {
    console.log(treeSelectedAHU, "treeSelectedAHU");
    if (!treeSelectedAHU?.id == null) {
      return;
    }
    setLoadingTreeFilters(true);
    try {
      const response = await fetch(
        `${getApiBaseUrl()}/filterph2/getFiltersList??BlockId=${
          treeSelectedBlock.id
        }&Status=0&Rfid=0&AHUId=${treeSelectedAHU.id}&AreaId=${
          treeSelectedArea.id
        }&ProcessType=${user}&pageNumber=1&recordslimit=10`,
      );
      const result = await response.json();
      setFilters(result?.ResultData || []);
    } catch (error) {
      console.error("Error fetching blocks:", error);
    } finally {
      setLoadingTreeFilters(false);
    }
  };

  useEffect(() => {
    fetchBlocks();
  }, []);

  useEffect(() => {
    setAreas([]);
    setTreeSelectedArea(null);
    setAHU([]);
    fetchAreas();
  }, [treeSelectedBlock]);

  useEffect(() => {
    setFilters([]);
    setTreeSelectedAHU(null);
    fetchAHU();
  }, [treeSelectedArea]);

  useEffect(() => {
    fetchFilters();
  }, [treeSelectedAHU]);

  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="page-header">
          <div className="add-item d-flex">
            <div className="page-title">
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/assetmgt/dashboard">
                      <i className="fas fa-home fa-lg" />
                    </Link>
                  </li>
                  <h4 className="breadcrumb-item" aria-current="page">
                    Filters List
                  </h4>
                </ol>
              </nav>
              <h6>Manage Filters</h6>
            </div>
          </div>

          <div className="page-btn">
            <button
              type="button"
              className="btn btn-success btn-sm"
              onClick={() =>
                setTreeBlockModal({
                  open: true,
                  mode: "BLOCK",
                })
              }
            >
              <i className="ti ti-circle-plus fa-xl"></i>
            </button>

            {/* Modal component MUST be rendered */}
            <FilterTreeAddBlockModels
              show={treeBlockModal.open}
              mode={treeBlockModal.mode}
              onClose={() => setTreeBlockModal({ open: false, mode: null })}
              blockName={clickedBlock}
              selectedBlock={treeSelectedBlock?.id}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-2 p-1">
            <div className="card">
              <div className="card-header ">
                {/* <div className="d-flex justify-content-between align-items-center">
                  <div className="">
                    <i className="  fa-solid fa-warehouse text-primary me-2 fa-lg"></i>
                    Blocks
                  </div>
                  <span className="badge badge-primary">{blocks?.length}</span>
                </div> */}
                <div className="d-flex justify-content-between align-items-center">
                  <Link
                    to="/assetmgt/Filters"
                    // Blockstate={{
                    //   blockId: treeSelectedBlock?.id,
                    //   blockName: treeSelectedBlock?.name,
                    // }}
                    // className={`fw-semibold ${
                    //   treeSelectedBlock ? "cursor-pointer" : "text-muted"
                    // }`}
                    // onClick={(e) => {
                    //   if (!treeSelectedBlock) {
                    //     e.preventDefault(); // stop navigation
                    //   }
                    // }}
                  >
                    <i className="fa-solid fa-warehouse text-primary me-2 fa-lg"></i>
                    Blocks
                  </Link>

                  <span className="badge badge-primary">{blocks?.length}</span>
                </div>

                {treeAreaModal.open && (
                  <FilterTreeAddAreaModel
                    show={true}
                    onClose={() => setTreeAreaModal({ open: false })}
                    blockName={treeSelectedBlock?.name}
                    selectedBlock={treeSelectedBlock?.id}
                    onSuccess={() => fetchAreas(treeSelectedBlock?.id)}
                    clickedBlock={clickedBlock}
                  />
                )}
                {editBlockModal.open && (
                  <FilterTreeEditBlock
                    show={true}
                    onClose={() => setEditBlockModal({ open: false })}
                    onSuccess={() => fetchBlocks()}
                    BlockData={editTreeSelectedBlock}
                  />
                )}
              </div>
              <div className="card-body p-1">
                {loadingTreeBlocks ? (
                  <div className="text-center my-4">
                    <Spin size="large" />
                    <p>Loading data...</p>
                  </div>
                ) : blocks.length > 0 ? (
                  blocks.map((block) => (
                    <div className="col-12 " key={block.BlockId}>
                      <Link
                        className="card mb-2"
                        style={{
                          backgroundColor:
                            treeSelectedBlock?.id === block.BlockId
                              ? "#e6f4ff"
                              : "white",
                          border:
                            treeSelectedBlock?.id === block.BlockId
                              ? "1px solid #1677ff"
                              : "1px solid #dee2e6",
                          cursor: "pointer",
                        }}
                      >
                        <div className="card-header d-flex justify-content-between align-items-center">
                          <span
                            className="fw-semibold"
                            onClick={() => {
                              setTreeSelectedBlock({
                                id: block.BlockId,
                                name: block.BlockName,
                              });
                              // setTreeSelectedArea(null);
                            }}
                          >
                            {block.BlockName}
                          </span>
                          {/* <div className="d-flex align-items-center gap-1">


                            <i
                              className="fa-solid fa-circle-plus text-primary fa-xl cursor-pointer"
                              title="Add Area"
                              onClick={() => {
                                setTreeAreaModal({
                                  open: true,
                                });
                                setClickedBlock(block.BlockName);
                              }}
                            ></i>

                             <i
                              className="fa-solid fa-pen-to-square text-primary fa-xl cursor-pointer"
                              title="Edit Ahu"
                              onClick={() => {
                                setEditTreeSelectedBlock(block); // ✅ full AHU object
                                setEditBlockModal({ open: true });
                              }}
                            />
                          </div> */}

                          <div className="d-flex align-items-center gap-2">
                            {/* Three dots dropdown */}
                            <div className="dropdown">
                              <i
                                className="fa-solid fa-ellipsis-vertical fa-lg cursor-pointer text-primary"
                                data-bs-toggle="dropdown"
                                aria-expanded="false"
                              ></i>

                              <ul className="dropdown-menu dropdown-menu-end shadow">
                                <li>
                                  <button
                                    className="dropdown-item d-flex align-items-center gap-2"
                                    onClick={() => {
                                      setTreeAreaModal({ open: true });
                                      setClickedBlock({
                                        blockName: block.BlockName,
                                        blockId: block.BlockId,
                                      });
                                    }}
                                  >
                                    <i className="fa-solid fa-circle-plus text-primary"></i>
                              
                                    Assign Area
                                  </button>
                                </li>

                                <li>
                                  <button
                                    className="dropdown-item d-flex align-items-center gap-2"
                                    onClick={() => {
                                      setEditTreeSelectedBlock(block);
                                      setEditBlockModal({ open: true });
                                    }}
                                  >
                                    <i className="fa-solid fa-pen-to-square text-primary"></i>
                                    Edit Block
                                  </button>
                                </li>
                              </ul>
                            </div>

                            <Link
                              to="/assetmgt/Filters"
                              state={{
                                blockId: treeSelectedBlock?.id,
                                blockName: treeSelectedBlock?.name,
                              }}
                              className={`fw-semibold ${
                                treeSelectedBlock
                                  ? "cursor-pointer"
                                  : "text-muted"
                              }`}
                              onClick={(e) => {
                                if (!treeSelectedBlock) {
                                  e.preventDefault(); // stop navigation
                                }
                              }}
                            >
                              <i
                                className="fa-solid fa-chevron-right text-primary fa-lg cursor-pointer"
                                title="View Assets"
                              ></i>
                            </Link>
                          </div>
                        </div>
                      </Link>
                    </div>
                  ))
                ) : (
                  <p className="text-center my-4">No data available</p>
                )}
              </div>
            </div>
          </div>
          <div className="col-2 p-1">
            <div className="card">
              <div className="card-header ">
                <div className="d-flex justify-content-between align-items-center">
                  <div className="">
                    <i className="fa-solid fa-location-dot text-primary me-2 fa-lg"></i>
                    Areas
                  </div>
                  <span className="badge badge-primary">{areas?.length}</span>
                </div>
                {AhuModal.open && (
                  <FilterTreeAddAhuModel
                    show={true}
                    onClose={() => setAhuModal({ open: false })}
                    onSuccess={() => fetchAHU(treeSelectedAHU?.id)}
                    blockName={treeSelectedBlock?.name}
                    blockId={treeSelectedBlock?.id}
                    areaName={clickedArea?.name}
                    areaId={clickedArea?.id}
                  />
                )}

                {editAreaModal.open && (
                  <FilterTreeEditArea
                    show={true}
                    blockName={treeSelectedBlock?.name}
                    blockId={treeSelectedBlock?.id}
                    areaName={treeSelectedArea?.name}
                    areaId={treeSelectedArea?.id}
                    onClose={() => setEditAreaModal({ open: false })}
                    onSuccess={() => fetchAreas(treeSelectedBlock?.id)}
                    areaData={editTreeSelectedArea}
                  />
                )}
              </div>
              <div className="card-body p-1">
                {loadingTreeAreas ? (
                  <div className="text-center my-4">
                    <Spin size="large" />
                    <p>Loading data...</p>
                  </div>
                ) : areas.length > 0 ? (
                  areas.map((area) => (
                    <div className="col-12 " key={area.Areaid}>
                      <Link
                        className="card mb-2"
                        style={{
                          backgroundColor:
                            treeSelectedArea?.id === area.Areaid
                              ? "#e6f4ff"
                              : "white",
                          border:
                            treeSelectedArea?.id === area.Areaid
                              ? "1px solid #1677ff"
                              : "1px solid #dee2e6",
                          cursor: "pointer",
                        }}
                      >
                        <div className="card-header d-flex justify-content-between align-items-center">
                          <span
                            className="fw-semibold"
                            onClick={() =>
                              setTreeSelectedArea({
                                id: area.Areaid,
                                name: area.AreaName,
                              })
                            }
                          >
                            {area.AreaName}
                          </span>
                          {/* <i
                            className="fa-solid fa-circle-plus text-primary fa-xl cursor-pointer"
                            title="Add AHU"
                            onClick={() => {
                              setClickedArea({
                                id: area.Areaid,
                                name: area.AreaName,
                              });

                              setAhuModal({
                                open: true,
                              });
                            }}
                          ></i> */}

                          <div className="d-flex align-items-center gap-2">
                            {/* Three dots dropdown */}
                            <div className="dropdown">
                              <i
                                className="fa-solid fa-ellipsis-vertical fa-lg cursor-pointer text-primary"
                                data-bs-toggle="dropdown"
                                aria-expanded="false"
                              ></i>

                              <ul className="dropdown-menu dropdown-menu-end shadow">
                                <li>
                                  <button
                                    className="dropdown-item d-flex align-items-center gap-2"
                                    onClick={() => {
                                      setClickedArea({
                                        id: area.Areaid,
                                        name: area.AreaName,
                                      });

                                      setAhuModal({
                                        open: true,
                                      });
                                    }}
                                  >
                                    <i
                                      className="fa-solid fa-circle-plus text-primary fa-xl cursor-pointer"
                                      title="Add AHU"
                                    ></i>
                                    Add AHU
                                  </button>
                                </li>

                                <li>
                                  <button
                                    className="dropdown-item d-flex align-items-center gap-2"
                                    onClick={() => {
                                      setEditTreeSelectedArea(area);
                                      setEditAreaModal({ open: true });
                                    }}
                                  >
                                    <i className="fa-solid fa-pen-to-square text-primary"></i>
                                    Edit Area
                                  </button>
                                </li>
                              </ul>
                            </div>

                            <Link
                              to="/assetmgt/Filters"
                              state={{
                                areaId: treeSelectedArea?.id,
                                areaName: treeSelectedArea?.name,
                              }}
                              className={`fw-semibold ${
                                treeSelectedArea
                                  ? "cursor-pointer"
                                  : "text-muted"
                              }`}
                              onClick={(e) => {
                                if (!treeSelectedArea) {
                                  e.preventDefault(); // stop navigation
                                }
                              }}
                            >
                              <i
                                className="fa-solid fa-chevron-right text-primary fa-lg cursor-pointer"
                                title="View Assets"
                              ></i>
                            </Link>
                          </div>
                        </div>
                      </Link>
                    </div>
                  ))
                ) : (
                  <p className="text-center my-4">No data available</p>
                )}
              </div>
            </div>
          </div>
          <div className="col-4 p-1">
            <div className="card">
              <div className="card-header ">
                <div className="d-flex justify-content-between align-items-center">
                  <div className="">
                    <i className="  fa-solid fa-wind text-primary me-2 fa-lg"></i>
                    AHUs
                  </div>
                  <div className="d-flex align-items-center gap-2">
                    <span className="badge badge-primary">{AHU?.length}</span>
                  </div>
                </div>
                {AddFilterModal.open && (
                  <FilterTreeAddFilterModel
                    onClose={() => setAddFilterModal({ open: false })}
                    blockName={treeSelectedBlock?.name}
                    onSuccess={() => fetchFilters(Fitermodel?.id)}
                    blockId={treeSelectedBlock?.id}
                    areaName={treeSelectedArea?.name}
                    ahuid={Fitermodel?.id}
                    ahuName={Fitermodel?.name}
                  />
                )}

                {editAhuModal.open && editTreeSelectedAhu && (
                  <FilterTreeEditAhuModel
                    onClose={() => setEditAhuModal({ open: false })}
                    onSuccess={() => fetchAHU(treeSelectedAHU?.id)}
                    blockName={treeSelectedBlock?.name}
                    blockId={treeSelectedBlock?.id}
                    areaName={treeSelectedArea?.name}
                    areaId={treeSelectedArea?.id}
                    ahuData={editTreeSelectedAhu} // ✅ ALL DETAILS
                  />
                )}
              </div>
              <div className="card-body p-1">
                {loadingTreeAHU ? (
                  <div className="text-center my-4">
                    <Spin size="large" />
                    <p>Loading data...</p>
                  </div>
                ) : AHU.length > 0 ? (
                  AHU.map((ahu) => (
                    <div className="col-12 " key={ahu.ID}>
                      <Link
                        className="card mb-2"
                        style={{
                          backgroundColor:
                            treeSelectedAHU?.id === ahu.ID
                              ? "#e6f4ff"
                              : "white",
                          border:
                            treeSelectedAHU?.id === ahu.ID
                              ? "1px solid #1677ff"
                              : "1px solid #dee2e6",
                          cursor: "pointer",
                        }}
                      >
                        <div className="card-header d-flex justify-content-between align-items-center ">
                          <span
                            className="fw-semibold"
                            onClick={() =>
                              setTreeSelectedAHU({
                                id: ahu.ID,
                                name: ahu.Code,
                              })
                            }
                          >
                            {ahu.Code}
                          </span>

                          <div className="d-flex align-items-center gap-3">
                            <i
                              className="fa-solid fa-circle-plus text-primary fa-xl cursor-pointer"
                              title="Add Filter"
                              onClick={() => {
                                setFitermodel({
                                  id: ahu.ID,
                                  name: ahu.Code,
                                });
                                setAddFilterModal({ open: true });
                              }}
                            />

                            <i
                              className="fa-solid fa-pen-to-square text-primary fa-xl cursor-pointer"
                              title="Edit Ahu"
                              onClick={() => {
                                setEditTreeSelectedAhu(ahu); // ✅ full AHU object
                                setEditAhuModal({ open: true });
                              }}
                            />
                          </div>
                        </div>
                      </Link>
                      {/* <Link className="card mb-2">
                    
                        <div className="card-header d-flex justify-content-between align-items-center">
                          <span
                            className="fw-semibold"
                            onClick={() =>
                              setTreeSelectedAHU({
                                id: ahu.ID,
                                name: ahu.Code,
                              })
                            }
                          >
                            {ahu.Code}
                          </span>

                          <div className="dropdown">
                            <i
                              className="fa-solid fa-ellipsis-vertical fa-xl cursor-pointer"
                              data-bs-toggle="dropdown"
                            ></i>

                            <ul className="dropdown-menu dropdown-menu-end shadow">
                              <li>
                                <button
                                  className="dropdown-item d-flex gap-2"
                                  onClick={() => {
                                 
                                    setTreeSelectedAHU({
                                      id: ahu.ID,
                                      name: ahu.Code,
                                    });
                                    setAddFilterModal({ open: true });
                                  }}
                                >
                                  <i className="fa-solid fa-circle-plus  text-primary"></i>
                                  Add Filter
                                </button>
                              </li>

                              <li>
                                <button
                                  className="dropdown-item d-flex gap-2"
                                  // onClick={() => handleEditAHU(ahu)}
                                >
                                  <i className="fa-solid fa-pen-to-square   text-primary"></i>
                                  Edit AHU
                                </button>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </Link> */}
                    </div>
                  ))
                ) : (
                  <p className="text-center my-4">No data available</p>
                )}
              </div>
            </div>
          </div>
          <div className="col-4 p-1">
            <div className="card">
              <div className="card-header ">
                <div className="d-flex justify-content-between align-items-center">
                  <div className="">
                    <i className="fa-solid fa-filter text-primary me-2 fa-lg"></i>
                    Filters
                  </div>
                  <div className="d-flex align-items-center gap-2">
                    <span className="badge badge-primary">
                      {filters?.length}
                    </span>
                  </div>
                </div>
                {editFilterModel.open && editTreeSelectedFilter && (
                  <FilterTreeEditFilterModel
                    onClose={() => setEditFilterModel({ open: false })}
                    onSuccess={() => fetchFilters(Fitermodel?.id)}
                    blockName={treeSelectedBlock?.name}
                    blockId={treeSelectedBlock?.id}
                    areaName={treeSelectedArea?.name}
                    areaId={treeSelectedArea?.id}
                    ahuid={treeSelectedAHU?.id}
                    ahuName={treeSelectedAHU?.name}
                    filterData={editTreeSelectedFilter} // ✅ ALL DETAILS
                  />
                )}
              </div>

              <div className="card-body p-1">
                {loadingTreeFilters ? (
                  <div className="text-center my-4">
                    <Spin size="large" />
                    <p>Loading data...</p>
                  </div>
                ) : filters.length > 0 ? (
                  filters.map((filter) => (
                    <div className="col-12 " key={filter.Id}>
                      <Link className="card mb-2">
                        <div className="card-header d-flex justify-content-between align-items-center">
                          <span className="fw-semibold">{filter.Lable}</span>

                          <div className="d-flex align-items-center gap-3">
                            <i
                              className="fa-solid fa-pen-to-square text-primary fa-xl cursor-pointer"
                              title="Edit Ahu"
                              onClick={() => {
                                setEditTreeSelectedFilter(filter); // ✅ full AHU object
                                setEditFilterModel({ open: true });
                              }}
                            />
                          </div>
                        </div>
                      </Link>
                    </div>
                  ))
                ) : (
                  <p className="text-center my-4">No data available</p>
                )}
              </div>
            </div>
          </div>
        </div>
        {/* <div className="card table-list-card">
          <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
            <div className="search-set m-3"></div>
            <div className="d-flex align-items-center flex-wrap gap-3 my-xl-auto right-content">
              <div style={{ minWidth: "250px" }}>
                <label className="fw-bold mb-1 d-block">Select Block:</label>
              </div>
            </div>
          </div>
          <div className="card-body">
            <div className="table-responsive"></div>
          </div>
        </div> */}
      </div>
    </div>
  );
};

export default FiltersTree;
